<script setup lang="ts">
import type { ContentResource } from "~/core/models/ContentResource.interface";
import contentService from "~/core/services/content.service";
import ILxcTrash2 from "~icons/lxc/trash-2";

const props = defineProps<{
  organizationCode?: number;
  selectedConfigurations: ContentResource[];
}>();

defineEmits(["delete", "cancelSelection"]);

const { t } = useI18n();

const selectedConfigurationUids: ComputedRef<string[]> = computed(() =>
  props.selectedConfigurations.map((configuration) => configuration.uid),
);

const deleteFn: () => Promise<void> = () => {
  return contentService.bulkDeleteContentResources(
    selectedConfigurationUids.value,
    props.organizationCode,
  );
};
</script>

<template>
  <quick-actions-toolbar
    :selection-message="
      t(
        'dtwins.form.configuration.delete.selectedConfigurations',
        selectedConfigurations.length,
      )
    "
    :quick-action-toolbar-class="[
      'border',
      'border-gray-400',
      '!bg-gray-200',
      '!text-primary-600',
      'font-medium',
    ]"
    @cancel-selection="$emit('cancelSelection')"
  >
    <delete-action
      :delete-fn="deleteFn"
      :title="
        t(
          'dtwins.form.configuration.delete.confirm.title',
          selectedConfigurations.length,
        )
      "
      :confirm-title="
        t(
          'dtwins.form.configuration.delete.confirm.title',
          selectedConfigurations.length,
        )
      "
      :confirm-description="
        t(
          'dtwins.form.configuration.delete.confirm.message',
          selectedConfigurations.length,
        )
      "
      :icon="ILxcTrash2"
      button-class="!visible !py-0"
      @success="$emit('delete')"
    />
  </quick-actions-toolbar>
</template>
